import {shoppingCart, claimTwinsMethodCoachingPackageClicked, GetCurrentPageName } from './cart'



// =========================================================
//        | TWINS METHOD PACKAGES UI CONTROLLER |
// =========================================================
// (If on a page they aren't available, there won't be any errors. We are using arrays from querySellectorAll)

export function InitializeTwinsMethodPackagesControls() {

    
    document.querySelectorAll('.ptm-private-coaching-packages').forEach(item => {
        // Get all Twins Method packages using .twins-method-packages (We have two of it's kind)
        // Loop over them, use the data-package values of their child .package-details-container to set the prices and 
        // Get their data-package as the TwinsMethod Package Code
        let twinsMethodPackage = item;
        setUpTwinsMethodPackageDetailsPlusEventListeners(twinsMethodPackage)
    });


    // Add Event Listener to Claim Twins Method Package button (Not using closure for item)
    document.querySelectorAll('.claim-twins-coaching-package').forEach(item => {
        item.addEventListener('click', claimTwinsMethodCoachingPackageClicked);
    });


    // Activate VIP three cycles by default
    let Vip3CyclesPackage = document.querySelector('.ptm-three-cycles-vip-package ')

    if (Vip3CyclesPackage != null) {
        Vip3CyclesPackage.click();
    }

}


function setUpTwinsMethodPackageDetailsPlusEventListeners(twinsMethodPackage) {

    // Add a click even listener on each .package-details-container

    //   When a click or tap occurs on any of them, loop through all of them and switch their icons 
    //  to unselected and remove border child .ptm-package-duration-text

    //  Finally set selected icon for clicked or tapped item 
    //  Also set the border for it's child .ptm-package-duration-text


    // query the .package-details-container in each twins-method-packages
    twinsMethodPackage.querySelectorAll('.ptm-package-details-container').forEach(packageDetailsContainer => {

        let pDataCon = packageDetailsContainer;
        // Get their data-package Atrribute
        const packageCode = pDataCon.getAttribute('data-package')
        if (packageCode === "") {
            console.log("package code not found in data-package attribute")
        }

        // Get the package data using packageCode
        let packageData = siteCoachingPackageByCode[packageCode]

        if (packageData == null){
            // Todo: Show error, Could not get package data
            console.log("no package found")
            return
        }

        // We got the packageData, now, use it to set the correct product display price
        const pricePTag = pDataCon.querySelector(".ptm-package-duration-amount");

        //  Set the price data for it's child .package-duration-amount
        pricePTag.textContent = packageData.formatted_price;

        // Reset their images .duration-icon-img src to unselected 
        pDataCon.querySelector("img").src = "/static-assets/img/unselected-bullet-point.svg";  
        
        // Remove underline from the package duration text
        const durationPTag = pDataCon.querySelector(".ptm-package-duration-text");
        durationPTag.classList.remove("ptm-selected-package-decor")


        // Add a click even listener on each .package-details-container with a closure
        pDataCon.addEventListener('click', twinsMethodPackageDetailsClicked(pDataCon));
    });

    
}

// Returns a Closure Event Listener
function twinsMethodPackageDetailsClicked(item) {

    return (event) => {

        // Run when event occurs
        // query all .package-details-container
        document.querySelectorAll('.ptm-package-details-container').forEach(packageDetailsContainer => {

            let pDataCon = packageDetailsContainer;

            const pDataConImg = pDataCon.querySelector("img");  

            const durationPTag = pDataCon.querySelector(".ptm-package-duration-text");
            
            // Set the global selected package code
            //  If the Event Target item is same as the current packageDetailsContainer
            if (item === pDataCon) {
                //If eventListener is same as this div
                // Would closure work here? or we should take in event object and take.target? (event.target kind of didn't work well. Couldn't get children element by event.target.querySelector("img") So I used closure to lock in item. Maybe using document.querySelector on event.target could work)


                // Get their data-package Atrribute
                const packageCode = pDataCon.getAttribute('data-package')
                if (packageCode === "") {
                    console.log("package code not found in data-package attribute")
                }

                // Set Global packageCode
                TwinsMethodCoachingPackageCode = packageCode


                // Set .duration-icon-img src to selected 
                pDataConImg.src = "/static-assets/img/selected-bullet-point.svg";

                // Add selected package decor class
                pDataCon.classList.add("ptm-selected-package-decor")
                // durationPTag.classList.add("selected-package-decor")

                
                /* We got the packageData, now, use it to set the button
                const claimTwinsMethodPackageButton = document.querySelector(".claim-twins-method-package");

                let claimPackageButtonText = "Join with ";
                let packageCategory = "VIP";
                let packageDuration = 3;
                let monthText = "months";

                // Check if packageCode contains vip
                if (!(packageCode.toLowerCase().includes("vip"))) {
                    packageCategory = "Standard"
                }

                // Check if it's 2 months or 1 month
                if (packageCode.toLowerCase().includes("2")) {
                    packageDuration = 2;
                } else if (packageCode.toLowerCase().includes("1")) {
                    packageDuration = 1;
                    monthText = "month"
                }

                claimPackageButtonText += packageCategory + " " + packageDuration + " " + monthText;

                //  Set the price data for it's child .package-duration-amount
                claimTwinsMethodPackageButton.textContent = claimPackageButtonText*/

            } else {

                // Reset their images .duration-icon-img src to unselected 
                pDataConImg.src = "/static-assets/img/unselected-bullet-point.svg";

                // remove the selected-package-decor class
                pDataCon.classList.remove("ptm-selected-package-decor")
                // durationPTag.classList.remove("selected-package-decor")
            }

        });


    }
}


/* ===========================================
        Attach Page Engagement Trackers
   ==========================================*/

// qcpackage-selector, section-btn (All have data-target)

export function InitializeTwinsMethodPageTrackingControls() {

    // Add Event Listener to make payment buttons
    document.querySelectorAll('.make-payment-btn').forEach(item => {
        item.addEventListener('click', SubmitTrackedPaymentButtonInfo);
    });

    // Add Event Listener to track pbm_trk_clk_evt click event
    document.querySelectorAll('.pbm_trk_clk_evt').forEach(item => {
        item.addEventListener('click', SubmitTrackedPbmClickInfo);
    });

    // // Add Event Listener to Home page
    // document.querySelectorAll('.pbm_trk_clk_evt').forEach(item => {
    //     item.addEventListener('click', SubmitTrackedPagesInfo);
    // });

    // Add Event Listener to Auth Pages
    document.querySelectorAll('.pbm_trk_auth_evt').forEach(item => {
        item.addEventListener('click', SubmitTrackedAuthEventInfo);
    });

    // Add Event Listener to track pbg_trk_cart_evt click event
    document.querySelectorAll('.pbg_trk_cart_evt').forEach(item => {
        item.addEventListener('click', SubmitTrackedPbgCartEventInfo);
    });


    // Add Event Listener to track generic click events
    document.querySelectorAll('.ptm_trk_clk_evt').forEach(item => {
        item.addEventListener('click', SubmitTrackedPagesInfo);
    });

    // Add Event Listener to packages page
    document.querySelectorAll('.pap_trk_clk_evt').forEach(item => {
        item.addEventListener('click', SubmitTrackedPagesInfo);
    });


}




async function SubmitTrackedPbgCartEventInfo(e) {

    // let eventTarget = e.target;
    // Get data-target property of the event target and 

    // Maybe we could use a general track_click_event or tr_clk_evt

    // target = element which event occured (Events could be propagated).
    // currentTarget = element on which event listener is attached
    let targetInfo = e.currentTarget.getAttribute("data-event");
    targetInfo = targetInfo.toLowerCase();

    let currentPage = GetCurrentPageName()

    return fetch('/page/trackevents/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({page: "cart event from: " + currentPage + " page", target: targetInfo}),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}



async function SubmitTrackedPbmClickInfo(e) {

    // let eventTarget = e.target;
    // Get data-target property of the event target and 

    // Maybe we could use a general track_click_event or tr_clk_evt

    // target = element which event occured (Events could be propagated).
    // currentTarget = element on which event listener is attached
    let targetInfo = e.currentTarget.getAttribute("data-event");
    targetInfo = targetInfo.toLowerCase();

    let currentPage = GetCurrentPageName()

    return fetch('/page/trackevents/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({page: currentPage, target: targetInfo}),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}


async function SubmitTrackedPagesInfo(e) {

    // let eventTarget = e.target;
    // Get data-target property of the event target and 

    // Maybe we could use a general track_click_event or tr_clk_evt

    // target = element which event occured (Events could be propagated).
    // currentTarget = element on which event listener is attached
    let targetInfo = e.currentTarget.getAttribute("data-event");
    targetInfo = targetInfo.toLowerCase();

    let pageName = e.currentTarget.getAttribute("data-page");

    return fetch('/page/trackevents/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({page: pageName + " landing page", target: targetInfo}),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}


async function SubmitTrackedPaymentButtonInfo(e) {

    // let eventTarget = e.target;
    // Get data-target property of the event target and 

    // Maybe we could use a general track_click_event or tr_clk_evt

    // target = element which event occured (Events could be propagated).
    // currentTarget = element on which event listener is attached
    let targetInfo = e.currentTarget.getAttribute("data-event");
    targetInfo = targetInfo.toLowerCase();

    let currentPage = GetCurrentPageName()

    return fetch('/page/trackevents/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({page: "payment options on page : " + currentPage, target: targetInfo}),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}


async function SubmitTrackedAuthEventInfo(e) {

    // let eventTarget = e.target;
    // Get data-target property of the event target and 

    // Maybe we could use a general track_click_event or tr_clk_evt

    // target = element which event occured (Events could be propagated).
    // currentTarget = element on which event listener is attached
    let targetInfo = e.currentTarget.getAttribute("data-event");

    let currentPage = e.currentTarget.getAttribute("data-page");

    return fetch('/page/trackevents/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({page: "auth event from : " + currentPage + " page", target: targetInfo}),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}

